/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Showcase_BanInputs */



/**
* | output |
* | --- |
* | "Taken off the public listing by staff" |
*
* @param {Activity_Showcase_BanInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_showcase_ban = /** @type {((inputs?: Activity_Showcase_BanInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Showcase_BanInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сотрудники Colossus убрали сервер из публичного списка")
	return /** @type {LocalizedString} */ ("Taken off the public listing by staff")
});